export const WEBXR_SUPPORT_STATUS = Object.freeze({
  supportedInCurrentBrowser: "supportedInCurrentBrowser",
  webxrUnavailable: "webxrUnavailable",
  likelyQuestBrowser: "likelyQuestBrowser",
  canShowSendToQuest: "canShowSendToQuest",
});

export function isLikelyQuestBrowser(userAgent = "") {
  return /\b(OculusBrowser|Meta Quest|Quest(?:\s(?:2|3|Pro))?|VR Browser)\b/i.test(userAgent);
}

export function getCurrentHttpsAppUrl(locationLike = globalThis.location) {
  if (!locationLike?.href) {
    return null;
  }

  try {
    const url = new URL(locationLike.href);
    return url.protocol === "https:" ? url.href : null;
  } catch (error) {
    return null;
  }
}

export function createMetaQuestLaunchUrl(appUrl) {
  if (!appUrl) {
    return null;
  }

  try {
    const url = new URL(appUrl);
    if (url.protocol !== "https:") {
      return null;
    }

    return `https://www.oculus.com/open_url/?url=${encodeURIComponent(url.href)}`;
  } catch (error) {
    return null;
  }
}

export async function detectWebXRSupport({
  navigator: navigatorLike = globalThis.navigator,
  location: locationLike = globalThis.location,
} = {}) {
  const likelyQuestBrowser = isLikelyQuestBrowser(navigatorLike?.userAgent ?? "");
  const currentHttpsUrl = getCurrentHttpsAppUrl(locationLike);
  const questLaunchUrl = createMetaQuestLaunchUrl(currentHttpsUrl);
  const canShowSendToQuest = Boolean(questLaunchUrl && !likelyQuestBrowser);
  const xr = navigatorLike?.xr;

  if (!xr || typeof xr.isSessionSupported !== "function") {
    return {
      status: canShowSendToQuest
        ? WEBXR_SUPPORT_STATUS.canShowSendToQuest
        : likelyQuestBrowser
          ? WEBXR_SUPPORT_STATUS.likelyQuestBrowser
          : WEBXR_SUPPORT_STATUS.webxrUnavailable,
      supportedInCurrentBrowser: false,
      likelyQuestBrowser,
      canShowSendToQuest,
      questLaunchUrl,
    };
  }

  try {
    const immersiveVrSupported = await xr.isSessionSupported("immersive-vr");

    if (immersiveVrSupported) {
      return {
        status: WEBXR_SUPPORT_STATUS.supportedInCurrentBrowser,
        supportedInCurrentBrowser: true,
        likelyQuestBrowser,
        canShowSendToQuest: false,
        questLaunchUrl: null,
      };
    }
  } catch (error) {
    // Treat transient or permission-related detection failures as unavailable.
  }

  return {
    status: likelyQuestBrowser
      ? WEBXR_SUPPORT_STATUS.likelyQuestBrowser
      : canShowSendToQuest
        ? WEBXR_SUPPORT_STATUS.canShowSendToQuest
        : WEBXR_SUPPORT_STATUS.webxrUnavailable,
    supportedInCurrentBrowser: false,
    likelyQuestBrowser,
    canShowSendToQuest,
    questLaunchUrl,
  };
}
